import { Box } from "@mui/material";
import { ReactComponent as IconArrow } from "assets/svg/chevron_right.svg";
import { ReactComponent as IconSuitcase } from "assets/svg/20-suitcase.svg";
import { ReactComponent as IconStopWatch } from "assets/svg/20-stopwatch.svg";
import { ReactComponent as IconCheckCircle } from "assets/svg/20-check-circle.svg";
import { ReactComponent as IconWarning } from "assets/svg/20-warning-outline.svg";
import { ReactComponent as IconFileEdit } from "assets/svg/20-file-edit.svg";

import moment from "moment";
import {
  NotiDateTime,
  NotificationIconWrapper,
  NotificationTitle,
  NotificationWrapper,
} from "./style";
import React from "react";
import {
  INotification,
  IReadStatus,
  ReadStatus,
} from "core/http/service/notification/types";
import { useNavigate } from "react-router-dom";
import pathRoutes from "routes/pathRoutes";
import { useDispatch, useSelector } from "react-redux";
import { updateNotificationStatusStart } from "modules/Notification/redux/updateNotiStatus";
import { accountInfoDataSelector } from "layouts/Sidenav/redux/selector";

interface NotificationItemProps {
  notification: INotification;
  onClickItem: () => void;
}

export const getUrlForNotification = (
  type: number,
  status: IReadStatus,
  isManager: boolean,
  objectId: string | number | undefined = undefined
) => {
  // trường hợp là nhân viên
  if (type === 18 && !isManager) {
    return {
      url: `${pathRoutes.declareLeave.base}/order-leave/leave/${objectId}`,
      icon: status === ReadStatus.READ ? <IconCheckCircle /> : <IconSuitcase />,
    };
  }
  if (type === 19 && !isManager) {
    return {
      url: `${pathRoutes.declareLeave.base}/order-leave/lack-of-time/${objectId}`,
      icon:
        status === ReadStatus.READ ? <IconCheckCircle /> : <IconStopWatch />,
    };
  }

  switch (type) {
    case 1:
    case 18:
    case 21:
      return {
        url: `${pathRoutes.declareLeave.base}/order-management/leave/${objectId}`,
        icon:
          status === ReadStatus.READ ? <IconCheckCircle /> : <IconSuitcase />,
      };

    case 2:
    case 20:
      return {
        url: `${pathRoutes.declareLeave.base}/order-leave/leave/${objectId}`,
        icon:
          status === ReadStatus.READ ? <IconCheckCircle /> : <IconSuitcase />,
      };

    case 3:
    case 19:
      return {
        url: `${pathRoutes.declareLeave.base}/order-management/lack-of-time/${objectId}`,
        icon:
          status === ReadStatus.READ ? <IconCheckCircle /> : <IconStopWatch />,
      };

    case 4:
      return {
        url: `${pathRoutes.declareLeave.base}/order-leave/lack-of-time/${objectId}`,
        icon:
          status === ReadStatus.READ ? <IconCheckCircle /> : <IconStopWatch />,
      };

    case 5:
      return {
        url: `${pathRoutes.declareLeave.base}/time-keeping/${objectId}`,
        icon: <IconWarning />,
      };

    case 6:
      return {
        url: `${pathRoutes.declareLeave.base}/order-management/list-feedback/${objectId}`,
        icon:
          status === ReadStatus.READ ? <IconCheckCircle /> : <IconFileEdit />,
      };

    case 7:
      return {
        url: `${pathRoutes.declareLeave.base}/order-leave/list-feedback/${objectId}`,
        icon:
          status === ReadStatus.READ ? <IconCheckCircle /> : <IconFileEdit />,
      };

    case 8:
    case 9:
    case 12:
      return {
        url: `${pathRoutes.declareLeave.base}/monthly-time-keeping/${objectId}`,
        icon:
          status === ReadStatus.READ ? <IconCheckCircle /> : <IconFileEdit />,
      };

    case 10:
    case 11:
    case 17:
      return {
        url: `${pathRoutes.declareLeave.base}/timeSheet-management/${objectId}`,
        icon:
          status === ReadStatus.READ ? <IconCheckCircle /> : <IconStopWatch />,
      };
    case 13:
      return {
        url: `${pathRoutes.declareLeave.base}/timeSheet-HR/${objectId}`,
        icon:
          status === ReadStatus.READ ? <IconCheckCircle /> : <IconStopWatch />,
      };
    case 14:
    case 15:
    case 16:
      return {
        url: `${pathRoutes.declareLeave.base}/time-keeping/${objectId}`,
        icon:
          status === ReadStatus.READ ? <IconCheckCircle /> : <IconStopWatch />,
      };
    case 23:
      return {
        url: `${pathRoutes.declareLeave.base}/order-leave/register-early/${objectId}`,
        icon:
          status === ReadStatus.READ ? <IconCheckCircle /> : <IconStopWatch />,
      };
    case 22:
      return {
        url: `${pathRoutes.declareLeave.base}/order-management/register-early/${objectId}`,
        icon:
          status === ReadStatus.READ ? <IconCheckCircle /> : <IconStopWatch />,
      };

    case 35:
    case 39:
    case 40:
    case 41:
    case 43:
    case 44:
      return {
        url: `${pathRoutes.recruitment.base}/${objectId}`,
        icon:
          status === ReadStatus.READ ? <IconCheckCircle /> : <IconStopWatch />,
      };

    case 46:
    case 47:
    case 49:
      return {
        url: `${pathRoutes.evaluation.base}/filter/${objectId}`,
        icon:
          status === ReadStatus.READ ? <IconCheckCircle /> : <IconStopWatch />,
      };
    case 50:
    case 52:
    case 53:
    case 54:
    case 55:
      return {
        url: `${pathRoutes.evaluation.base}/schedule/${objectId}`,
        icon:
          status === ReadStatus.READ ? <IconCheckCircle /> : <IconStopWatch />,
      };
    case 57:
      return {
        url: `${pathRoutes.salary.tabs.regular}`,
        icon:
          status === ReadStatus.READ ? <IconCheckCircle /> : <IconStopWatch />,
      };

    case 30:
    case 31:
    case 32:
    case 34:
    case 35:
    case 36:
    case 37:
      return {
        url: `${pathRoutes.recruitment.base}`,
        icon:
          status === ReadStatus.READ ? <IconCheckCircle /> : <IconStopWatch />,
      };
    default:
      return {
        url: "/",
        icon: <></>,
      };
  }
};

export const NotificationItem = ({
  notification,
  onClickItem,
}: NotificationItemProps) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { manager } = useSelector(accountInfoDataSelector);

  const { icon, url } = getUrlForNotification(
    notification.noticeType,
    notification.readStatus,
    manager,
    notification.objectId || ""
  );

  const { createdAt, readStatus } = notification;

  const time = `${moment(createdAt).get("hour")}h${moment(createdAt).get("minute")} - Ngày ${moment(createdAt).format("DD/MM/YYYY")}`;
  const type =
    readStatus === ReadStatus.READ
      ? "read"
      : notification.noticeType === 1
        ? "leave"
        : "late";

  const handleClickOnNotification = () => {
    navigate(url);

    if (readStatus === ReadStatus.UNREAD) {
      dispatch(
        updateNotificationStatusStart({
          id: notification.id,
          readStatus: ReadStatus.READ as IReadStatus,
        })
      );
    }
    onClickItem();
  };

  return (
    <NotificationWrapper
      isNew={readStatus === ReadStatus.UNREAD}
      onClick={handleClickOnNotification}
    >
      <NotificationIconWrapper
        isNew={readStatus === ReadStatus.UNREAD}
        type={type}
      >
        <>{icon}</>
      </NotificationIconWrapper>
      <Box flex={1}>
        <Box display={"flex"} justifyContent={"space-between"} gap={1}>
          <NotificationTitle isNew={readStatus === ReadStatus.UNREAD}>
            {notification.title}
          </NotificationTitle>
          {type !== "read" && <IconArrow />}
        </Box>
        <NotiDateTime isNew={readStatus === ReadStatus.UNREAD}>
          {time}
        </NotiDateTime>
      </Box>
    </NotificationWrapper>
  );
};
